export default __webpack_public_path__ + "static/media/dino@2x.480064cd.png";